import { render, staticRenderFns } from "./CustomAddEdit.vue?vue&type=template&id=621be32a&"
import script from "./CustomAddEdit.vue?vue&type=script&lang=js&"
export * from "./CustomAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports